module.exports = __webpack_public_path__ + "img/Group 484.ad080fbd.svg";